import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.results');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

interface GenerationSummary {
    participant_count: number;
    batch_count: number;
    set_count: number;
    evaluated_set_count: number;
    pending_set_count: number;
    winning_set_count: number;
    non_winning_set_count: number;
    rank_1: number;
    rank_2: number;
    rank_3: number;
    rank_4: number;
    rank_5: number;
    reference_prize_amount: number;
    hit_rate: number;
}

interface RoundSummary extends GenerationSummary {
    draw_no: number;
    draw_date: string | null;
    numbers: number[];
    bonus: number | null;
    status: 'completed' | 'pending' | 'unavailable';
}

interface DrawOption {
    draw_no: number;
    draw_date: string;
}

@Component({
    selector: 'wiz-page-results',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.results/view.scss */
:host {
  display: block;
}

.results-page {
  color: #0f172a;
}

.results-tabs {
  border: 1px solid rgba(15, 23, 42, 0.07);
  background: rgba(118, 118, 128, 0.12);
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.035);
}

.results-tabs button {
  color: #6b7280;
}

.results-tabs button.is-active {
  background: rgba(255, 255, 255, 0.96);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.95), 0 1px 3px rgba(15, 23, 42, 0.11), 0 4px 12px rgba(15, 23, 42, 0.045);
  color: #0f172a;
}

.results-overview-grid {
  display: grid;
  gap: 0.625rem;
}

.community-lead-grid {
  display: grid;
  gap: 0.625rem;
}

.community-section-label {
  color: #8e8e93;
  font-size: 0.625rem;
  font-weight: 800;
  letter-spacing: 0.015em;
}

.community-current-card {
  border-color: rgba(15, 23, 42, 0.075);
  background: #f4f3ef;
  color: #1d1d1f;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.88), 0 2px 8px rgba(15, 23, 42, 0.04), 0 14px 34px rgba(15, 23, 42, 0.055);
}

.community-current-status {
  color: #80611a;
}

.community-current-summary {
  border-top: 1px solid rgba(15, 23, 42, 0.075);
  background: rgba(255, 255, 255, 0.54);
}

.community-current-summary > div {
  padding: 0.7rem 0.875rem;
}

.community-current-summary > div + div {
  border-left: 1px solid rgba(15, 23, 42, 0.07);
}

.community-current-summary dt {
  color: #8e8e93;
  font-size: 0.5625rem;
  font-weight: 750;
}

.community-current-summary dd {
  margin-top: 0.125rem;
  color: #27272a;
  font-size: 1rem;
  font-weight: 900;
}

.latest-community-card {
  border-color: rgba(24, 24, 27, 0.92);
  background: #1d1d1f;
  color: #fff;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.09), 0 3px 10px rgba(15, 23, 42, 0.13), 0 18px 40px rgba(15, 23, 42, 0.14);
}

.latest-community-card .community-section-label,
.latest-community-heading p:last-child,
.latest-community-result > p,
.latest-community-result > div > p:first-child {
  color: rgba(255, 255, 255, 0.58);
}

.latest-community-arrow {
  color: rgba(255, 255, 255, 0.48);
}

.latest-community-card:hover {
  border-color: #27272a;
  background: #242426;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.11), 0 4px 12px rgba(15, 23, 42, 0.15), 0 22px 48px rgba(15, 23, 42, 0.17);
  transform: translateY(-1px);
}

.latest-community-card:active {
  transform: scale(0.995);
}

.service-cumulative-section {
  padding-top: 0.125rem;
}

.cumulative-card {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.08);
  background: #fff;
  color: #111827;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.98), 0 2px 8px rgba(15, 23, 42, 0.045), 0 20px 46px rgba(15, 23, 42, 0.075);
}

.cumulative-primary {
  position: relative;
  z-index: 1;
  background: #fff;
}

.cumulative-label {
  color: #8e8e93;
}

.cumulative-participants {
  color: #8e8e93;
  font-variant-numeric: tabular-nums;
}

.cumulative-summary {
  position: relative;
  z-index: 1;
  margin-top: auto;
  border-top: 1px solid #e8e8e5;
  background: #f7f7f5;
}

.cumulative-summary dt {
  color: #8e8e93;
}

.cumulative-summary > div + div {
  border-left: 1px solid #e5e5e2;
}

.rank-result-card {
  border-color: rgba(15, 23, 42, 0.08);
  background: #fff;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.96), 0 2px 8px rgba(15, 23, 42, 0.045), 0 20px 46px rgba(15, 23, 42, 0.075);
}

.hit-rate-label {
  color: #68686d;
  font-variant-numeric: tabular-nums;
}

.rank-result-card .rank-grid,
.round-rank-section .rank-grid {
  border-color: #e7e7e4;
  background: #fafaf9;
}

.rank-cell {
  transition: background-color 0.18s ease, box-shadow 0.18s ease;
}

.rank-card-footer {
  border-color: #ececea;
}

.pending-status-dot {
  width: 0.5rem;
  height: 0.5rem;
  flex: 0 0 auto;
  border-radius: 9999px;
  background: #d5a72b;
  box-shadow: 0 0 0 4px rgba(213, 167, 43, 0.12);
}

.recent-results-shell {
  border-color: rgba(15, 23, 42, 0.08);
  background: rgba(255, 255, 255, 0.94);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.96), 0 2px 8px rgba(15, 23, 42, 0.04), 0 18px 42px rgba(15, 23, 42, 0.065);
}

.result-row {
  transition: background-color 0.15s ease, padding-left 0.15s ease;
}

.result-row:hover {
  background: #f8f8f6;
}

.round-picker {
  border-color: rgba(15, 23, 42, 0.08);
  background: rgba(246, 246, 243, 0.94);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.96), 0 1px 2px rgba(15, 23, 42, 0.035), 0 10px 28px rgba(15, 23, 42, 0.045);
}

.round-picker-grid {
  display: grid;
  gap: 0.375rem;
}

.round-control {
  height: 2.65rem;
  border-color: rgba(15, 23, 42, 0.1);
  background: #fff;
  color: #111827;
  box-shadow: inset 0 1px 1px rgba(15, 23, 42, 0.025), 0 1px 2px rgba(15, 23, 42, 0.025);
  transition: border-color 0.16s ease, box-shadow 0.16s ease, background-color 0.16s ease;
}

.round-control:hover {
  border-color: rgba(15, 23, 42, 0.2);
  background: #fff;
}

.round-control:focus {
  border-color: #f59e0b;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.13);
}

.round-view-button {
  min-width: 3.25rem;
  background: #18181b;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 4px 10px rgba(15, 23, 42, 0.14);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.round-view-button:hover:not(:disabled) {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.14), 0 7px 16px rgba(15, 23, 42, 0.22);
  transform: translateY(-1px);
}

.selected-round-card {
  border-color: rgba(15, 23, 42, 0.08);
  border-radius: 1.25rem;
  background: #fff;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.98), 0 2px 8px rgba(15, 23, 42, 0.045), 0 24px 56px rgba(15, 23, 42, 0.095);
}

.round-hero {
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid #ececea;
  background: #fff;
  color: #111827;
}

.round-hero > * {
  position: relative;
  z-index: 1;
}

.round-heading p:last-child {
  color: #8e8e93;
  font-variant-numeric: tabular-nums;
}

.round-status {
  display: inline-flex;
  min-height: 1.625rem;
  flex: 0 0 auto;
  align-items: center;
  font-size: 0.5625rem;
  font-weight: 900;
}

.round-status::before {
  width: 0.35rem;
  height: 0.35rem;
  margin-right: 0.35rem;
  border-radius: 9999px;
  background: currentColor;
  content: "";
}

.round-status.is-completed {
  color: #237a55;
}

.round-status.is-pending {
  color: #8a641b;
}

.round-pending-message {
  border: 1px solid #ece3ce;
  background: #faf7ef;
  color: #735718;
}

.round-summary-grid {
  border-bottom: 1px solid #e8e8e5;
  background: #f7f7f5;
}

.round-rank-section {
  background: #fff;
}

.round-rank-section .rank-grid {
  border-color: #e7e7e4;
  background: #fafaf9;
}

.round-rank-heading {
  color: #172033;
}

.round-rank-heading p:last-child {
  color: #6b5b39;
}

.round-empty {
  background: #fafaf8;
  color: #94a3b8;
}

.metric-value {
  overflow-wrap: anywhere;
  font-variant-numeric: tabular-nums;
}

.result-value-winning {
  color: #8b6215;
}

.rank-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.rank-cell + .rank-cell {
  border-left: 1px solid #e2e8f0;
}

.round-stat {
  min-width: 0;
  padding: 0.75rem 0.25rem;
  transition: background-color 0.18s ease;
}

.round-stat + .round-stat {
  border-left: 1px solid #e5e5e2;
}

.recent-round-result {
  max-width: min(55vw, 18rem);
  line-height: 1.4;
}

.number-row {
  display: flex;
  width: 100%;
  max-width: 27rem;
  align-items: center;
  justify-content: space-between;
  gap: 0.25rem;
}

.result-ball {
  display: inline-flex;
  width: 2rem;
  height: 2rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.34), 0 3px 9px rgba(15, 23, 42, 0.14);
  font-size: 0.68rem;
  font-weight: 900;
}

.bonus-plus {
  display: inline-flex;
  width: 0.7rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  color: #ef4444;
  font-size: 1.05rem;
  font-weight: 900;
  line-height: 1;
}

.bonus-group {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  padding: 0.16rem;
  border: 1px solid #fca5a5;
  border-radius: 0.55rem;
  background: #fff7f7;
  box-shadow: 0 2px 7px rgba(239, 68, 68, 0.09);
}

.bonus-ball {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.28);
}

.ball-yellow {
  background: #fbbf24;
  color: #0f172a;
}

.ball-blue {
  background: #3b82f6;
  color: #fff;
}

.ball-red {
  background: #ef4444;
  color: #fff;
}

.ball-gray {
  background: #64748b;
  color: #fff;
}

.ball-green {
  background: #10b981;
  color: #fff;
}

button:focus-visible,
select:focus-visible,
input:focus-visible {
  outline: 3px solid rgba(251, 191, 36, 0.55);
  outline-offset: 2px;
}

@media (max-width: 359px) {
  .results-page {
    padding-right: 0.625rem;
    padding-left: 0.625rem;
  }
  .rank-cell {
    padding: 0.65rem 0.2rem;
  }
  .round-stat {
    padding-right: 0.15rem;
    padding-left: 0.15rem;
  }
  .round-stat dt {
    font-size: 0.5625rem;
    letter-spacing: -0.035em;
  }
  .round-stat dd {
    font-size: 0.875rem;
  }
  .result-ball {
    width: 1.65rem;
    height: 1.65rem;
    font-size: 0.625rem;
  }
}
@media (max-width: 319px) {
  .cumulative-summary dt,
  .rank-cell p:first-child {
    font-size: 0.5625rem;
  }
  .cumulative-summary dd,
  .rank-cell .metric-value {
    font-size: 0.875rem;
  }
  .result-ball {
    width: 1.5rem;
    height: 1.5rem;
    font-size: 0.625rem;
  }
}
@media (min-width: 640px) {
  .round-picker-grid {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
  .round-stat {
    padding: 0.875rem 0.75rem;
  }
  .result-ball {
    width: 2.15rem;
    height: 2.15rem;
    font-size: 0.72rem;
  }
  .number-row {
    justify-content: flex-start;
    gap: 0.45rem;
  }
}
@media (min-width: 768px) {
  .community-lead-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;
  }
  .results-overview-grid {
    grid-template-columns: minmax(0, 0.82fr) minmax(0, 1.18fr);
    gap: 0.75rem;
  }
  .round-hero {
    display: grid;
    grid-template-columns: minmax(0, 14rem) minmax(0, 1fr);
    align-items: center;
    gap: 1.25rem;
  }
  .round-hero .number-row {
    margin-top: 0;
  }
  .round-hero .round-pending-message {
    grid-column: 1/-1;
  }
}`],
})
export class PageResultsComponent implements OnInit {
    public loading: boolean = true;
    public roundLoading: boolean = false;
    public activeScope: 'cumulative' | 'round' = 'cumulative';
    public initialError: string = '';
    public roundError: string = '';
    public latestDrawNo: number = 0;
    public cumulative: GenerationSummary = this.emptySummary();
    public selectedRound: RoundSummary | null = null;
    public upcomingRound: RoundSummary | null = null;
    public recentRounds: RoundSummary[] = [];
    public latestResult: RoundSummary | null = null;
    public pastRounds: RoundSummary[] = [];
    public drawOptions: DrawOption[] = [];
    public pickerDrawNo: string | number = '';
    public manualDrawNo: string | number = '';
    public ranks: number[] = [1, 2, 3, 4, 5];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await (this.service as any).init();
        const allowed = await this.service.auth.allow('/access');
        if (!allowed) return;
        await this.load();
    }

    public async load() {
        this.loading = true;
        this.initialError = '';
        await this.service.render();

        try {
            const result: any = await wiz.call('overview');
            const data = result.data || {};
            if (result.code !== 200) {
                this.initialError = data.message || '전체 결과를 불러오지 못했습니다.';
                return;
            }
            this.applyOverview(data);
        } catch (error) {
            this.initialError = '네트워크 연결을 확인한 뒤 다시 시도해주세요.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async retryLoad() {
        await this.load();
    }

    public async setScope(scope: 'cumulative' | 'round') {
        this.activeScope = scope;
        if (scope === 'round' && this.selectedRound) {
            this.pickerDrawNo = this.selectedRound.draw_no;
        }
        await this.service.render();
    }

    public async selectRecent() {
        if (!this.pickerDrawNo || this.roundLoading) return;
        await this.openRound(Number(this.pickerDrawNo));
    }

    public async openManualRound() {
        const drawNo = Number(this.manualDrawNo);
        if (!Number.isInteger(drawNo) || drawNo < 1 || drawNo > this.latestDrawNo) {
            await this.service.modal.error(
                '1회부터 ' + this.latestDrawNo + '회 사이의 숫자를 입력해주세요.'
            );
            return;
        }
        await this.openRound(drawNo);
    }

    public async openRound(drawNo: number) {
        if (this.roundLoading || !Number.isInteger(drawNo) || drawNo < 1) return;
        this.activeScope = 'round';
        this.roundLoading = true;
        this.roundError = '';
        this.pickerDrawNo = drawNo;
        await this.service.render();

        try {
            const result: any = await wiz.call('overview', { draw_no: drawNo });
            const data = result.data || {};
            if (result.code !== 200) {
                this.roundError = data.message || '회차 결과를 불러오지 못했습니다.';
                return;
            }
            this.applyOverview(data);
            this.manualDrawNo = '';
        } catch (error) {
            this.roundError = '네트워크 연결을 확인한 뒤 다시 시도해주세요.';
        } finally {
            this.roundLoading = false;
            await this.service.render();
        }
    }

    public async retryRound() {
        const drawNo = this.selectedRound?.draw_no || Number(this.pickerDrawNo);
        if (drawNo) await this.openRound(drawNo);
    }

    public rankCount(summary: GenerationSummary | null, rank: number) {
        if (!summary) return 0;
        return Number((summary as any)['rank_' + rank] || 0);
    }

    public hitRate(summary: GenerationSummary | null) {
        if (!summary || !summary.evaluated_set_count) return '0%';
        const value = Number(summary.hit_rate || 0);
        return value < 0.01 ? '<0.01%' : value.toFixed(value < 1 ? 2 : 1) + '%';
    }

    public roundResultLabel(round: RoundSummary) {
        if (round.set_count === 0) return '생성 없음';
        if (round.pending_set_count > 0 && round.evaluated_set_count === 0) {
            return '전체 ' + round.set_count + '조합 · 결과 대기';
        }
        return '전체 ' + round.set_count + '조합 · 5등 이상 ' + round.winning_set_count + '조합';
    }

    public winningHeadline(round: RoundSummary) {
        if (round.winning_set_count > 0) {
            return round.winning_set_count + '조합 당첨';
        }
        return '당첨 조합 없음';
    }

    public shortDate(value: any) {
        const text = String(value || '');
        if (!text) return '';
        return text.slice(0, 10).replace(/-/g, '.');
    }

    public numberClass(number: number | null) {
        number = Number(number || 0);
        if (number <= 10) return 'ball-yellow';
        if (number <= 20) return 'ball-blue';
        if (number <= 30) return 'ball-red';
        if (number <= 40) return 'ball-gray';
        return 'ball-green';
    }

    public trackByDrawNo(index: number, round: RoundSummary) {
        return round.draw_no;
    }

    private applyOverview(data: any) {
        this.latestDrawNo = Number(data.latest_draw_no || 0);
        this.cumulative = data.cumulative || this.emptySummary();
        this.selectedRound = data.selected_round || null;
        this.upcomingRound = data.upcoming_round || null;
        this.recentRounds = data.recent_rounds || [];
        this.latestResult = this.recentRounds.length ? this.recentRounds[0] : null;
        this.pastRounds = this.recentRounds.slice(1);
        this.drawOptions = data.options || [];
        if (this.selectedRound && !this.pickerDrawNo) {
            this.pickerDrawNo = this.selectedRound.draw_no;
        }
    }

    private emptySummary(): GenerationSummary {
        return {
            participant_count: 0,
            batch_count: 0,
            set_count: 0,
            evaluated_set_count: 0,
            pending_set_count: 0,
            winning_set_count: 0,
            non_winning_set_count: 0,
            rank_1: 0,
            rank_2: 0,
            rank_3: 0,
            rank_4: 0,
            rank_5: 0,
            reference_prize_amount: 0,
            hit_rate: 0
        };
    }
}

export default PageResultsComponent;